var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reports-wrap"},[(!_vm.isIndex)?_c('router-link',{staticClass:"view-header__btn reports-back-btn",attrs:{"to":"/reports"}},[_c('i',{staticClass:"bi bi-arrow-left"}),_vm._v(" Volver a reportes ")]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }